import { fetcher } from "../../utils/fetcher.js";

// Super admin: create, update and delete banners
export const createSystemBanner = (banner) =>
  fetcher.post("/api/system-banners", banner);

export const updateSystemBanner = (id, changes) =>
  fetcher.put(`/api/system-banners/${id}`, changes);

// Show the banner again to users who closed it
export const reshowSystemBanner = (id) =>
  fetcher.post(`/api/system-banners/${id}/reshow`);

export const deleteSystemBanner = (id) =>
  fetcher.delete(`/api/system-banners/${id}`);
